import MuiPaper, { type PaperProps } from "@mui/material/Paper";

type Props = Pick<
  PaperProps,
  "elevation" | "variant" | "children" | "className"
>;

export const Paper = (props: Props) => <MuiPaper {...props} />;
